export const GET_ALL_TRADERS = "GET_ALL_TRADERS";
export const GET_SPECEFIC_TRADER = "GET_SPECEFIC_TRADER";
